import type { RefObject } from 'react';
import { IconButton } from '@mui/material';
import { Settings as ConfigureChecksIcon } from '@mui/icons-material';
import ActionHelpTooltip from '../../../shared/ui/common/ActionHelpTooltip';
import { validationActionTooltips } from '../../../shared/config/actionHelpCatalog';

type ValidationHeaderConfigurationActionsProps = {
  readonly loading: boolean;
  readonly canConfigureMappings: boolean;
  readonly onShowConfig: () => void;
  readonly configureChecksRef?: RefObject<HTMLButtonElement | null>;
  readonly buttonSx: object;
};

export default function ValidationHeaderConfigurationActions({
  loading,
  canConfigureMappings,
  onShowConfig,
  configureChecksRef,
  buttonSx,
}: ValidationHeaderConfigurationActionsProps) {
  const disabled = loading || !canConfigureMappings;
  return (
    <ActionHelpTooltip help={validationActionTooltips.configureChecks} placement="bottom">
      <IconButton
        ref={configureChecksRef}
        data-testid="validation-tour-target-header-configure"
        size="small"
        aria-label="Configure validation checks"
        onClick={onShowConfig}
        disabled={disabled}
        sx={buttonSx}
      >
        <ConfigureChecksIcon fontSize="small" />
      </IconButton>
    </ActionHelpTooltip>
  );
}
